module.exports = __webpack_public_path__ + "static/img/right_icon.a1f8b6f4.svg";